import React, { FunctionComponent} from 'react';
import './Footer.css';

interface INavMenuProps { }



export const Footer: FunctionComponent<INavMenuProps> = () => {


  return (
    <footer className="footer bg-footer footer-img">
    <div className="container-fluid " >
      <div className="row">
        <div className="col-sm-6">
          
        </div>
        <div className="col-sm-6">
          <div className="text-sm-end d-none d-sm-block">
          
          </div>
        </div>
      </div>
    </div>
  </footer>
  );
}
